// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"ElectronicConsent_checkboxLabel__26wvc","checkboxContainer":"ElectronicConsent_checkboxContainer__8b0We","footerText":"ElectronicConsent_footerText__XC7QH"};